import clsx from 'clsx';
import React from 'react';

const LayoutHeader = ({ header, children, footer, imageBackground, textInImageBackground, courseGradient, className, style }) => {
  return (
    <div className={clsx('layout-header', className, { 'layout-header--with-footer': footer })} style={style}>
      {header && <div className="layout-header__header">{header}</div>}
      {(imageBackground || courseGradient) && (
        <div className="layout-header__background-image" style={{ backgroundImage: imageBackground ? `url(${imageBackground})` : courseGradient }}>
          <div className="layout-header__background-text-container">
            <span className="layout-header__background-text">{textInImageBackground}</span>
          </div>
        </div>
      )}
      <div className="layout-header__content" id="layout-header__content">
        <div className="layout-header__children">{children}</div>
      </div>
      {footer && <div className="layout-header__footer">{footer}</div>}
    </div>
  );
};

export default LayoutHeader;
